module.exports = __webpack_public_path__ + "static/media/Societe-Valorisation-Immobiliere-Vaud.479f1a3b.jpg";